import {useAppContext} from "../../utils/AppContext";

const Testimonials = () => {
    const {
        projectData,
        isMediumScreen, isSmallScreen,
        screenSize,      
    } = useAppContext();

    // Styles Configuration //
    const testimonialsContainer = (!screenSize)? 'testimonials-container' : `testimonials-container testimonials-container${screenSize}`;
    const sectionTitle = (!screenSize)? "section-title scroll-section-title" : `section-title scroll-section-title${screenSize} section-title${screenSize}`;
    const testimonialsItemsContainer = (!screenSize)? "testimonials-items-container" : `testimonials-items-container testimonials-items-container${screenSize}`;
    const testimonialItemContainer = (!screenSize)? "testimonial-item-container" : `testimonial-item-container testimonial-item-container${screenSize}`;
    const testimonialItemTopSection = (!screenSize)? "testimonial-item-top-section" : `testimonial-item-top-section testimonial-item-top-section${screenSize}`;
    const itemTitle = (!screenSize)? "item-title" : `item-title item-title${screenSize}`;
    const regularTextLight = (!screenSize)? "regular-text-light" : `regular-text-light regular-text-light${screenSize}`;
    const smallTextLight = (!screenSize)? "small-text-light" : `small-text-light small-text-light${screenSize}`;


    const renderTestimonial = ({item, index}) => (
        <div
            className={testimonialItemContainer}
            key={index}
        >
            <div className={testimonialItemTopSection}>
                <h5 className={itemTitle}>"{item.title}"</h5>
                <p className={regularTextLight}>"{item.content}"</p>
            </div>
            <span className={smallTextLight}>{item.author}</span>
        </div>
    );

    return (
        <div className={testimonialsContainer}>
            <h2 className={sectionTitle}>{projectData.testimonials.title}</h2>
            {!(isMediumScreen || isSmallScreen)?
                <div className={testimonialsItemsContainer}>
                    <div className="testimonials-items-scroll">
                        {projectData.testimonials.items.map((item, index) => (
                            renderTestimonial({item, index})
                        ))}
                    </div>
                </div>
                :
                <div className={testimonialsItemsContainer}>
                    {projectData.testimonials.items.map((item, index) => (
                        renderTestimonial({item, index})
                    ))}
                </div>
            }
        </div>
    );

};

export default Testimonials;
